import React from 'react';
import styled, { css } from 'styled-components';
import { ItemGrid } from './ContentsItemLayout';

const Component = styled.div<{
  $spacing?: 'xxs' | 'xs' | 'xsm' | 'sm' | 'md' | 'xlg' | 'lg' | 'xl';
}>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  ${(props) => {
    if (props.$spacing) {
      return css`
        width: calc(100% + ${props.theme.spacing[props.$spacing] * 2}px);
        margin: -${props.theme.spacing[props.$spacing]}px;
        ${ItemGrid} {
          padding: 5px;
        }
      `;
    }
    return css`
      padding: 0px;
    `;
  }}
`;

interface ContentBodyLayoutProps {
  className?: string;
  children?: React.ReactNode;
}

const ContentBodyLayout = ({ children, className }: ContentBodyLayoutProps) => {
  return (
    <Component className={className} $spacing="xsm">
      {children}
    </Component>
  );
};

export default ContentBodyLayout;
